import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Header from "../components/Header"

const Terms: React.FC = () => {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			// behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoSoonOverHeader.jpg"} />
					<img src={"/images/promoSoonOverHeader.jpg"} className=" block w-full" alt="Danke" />
				</picture>

				<h2 className="md:text-[70px] text-[25px]  absolute left-0 bottom-[40%] translate-y-1/2 w-full  text-center  ">
					Teilnahme&shy;bedingungen
				</h2>
			</div>
			<div className="container mx-auto max-w-[800px] py-8 px-4 text-justify">
				<h2 className="h2 text-black leading-tight"></h2>
				<p className="mb-8 ">
					Mit der Teilnahme am Wilkinson BULLDOG Ironman Gewinnspiel 2026 („Aktion“) akzeptiert der Teilnehmer
					die folgenden Teilnahmebedingungen:
				</p>
				<h3 className="h3 text-black py-4">1. Veranstalter</h3>
				<p className="mb-8 ">
					Veranstalter dieses Gewinnspiels ist{" "}
					<strong>Wilkinson Sword GmbH, Schützenstraße 110, D-42659 Solingen, Deutschland</strong>{" "}
					(„Veranstalter"). Er veranstaltet{" "}
					<strong>im Zeitraum vom 25.05.2026 bis zum 05.07.2026, 23:59 Uhr</strong> (deutsche Zeit)
					(„Aktionszeitraum“), eine zeitlich begrenzte Gewinnspiel-Aktion mit Gewinnspiel für die Marke
					BULLDOG („Aktion").
				</p>
				<p className="mb-8 ">
					Die Aktion wird von der{" "}
					<strong>Magellan GmbH, Champion-Straße 2, 40549 Düsseldorf, Deutschland</strong> und der{" "}
					<strong>
						direct services Gütersloh GmbH, Reinhard-Mohn-Str. 300, 33333 Gütersloh, Deutschland
					</strong>{" "}
					durchgeführt.
				</p>
				<h3 className="h3 text-black py-4">2. Teilnahmeberechtigung</h3>
				<p className="mb-8 ">
					Teilnehmen dürfen <strong>natürliche Personen ab 18 Jahren mit Wohnsitz in Deutschland</strong>, die
					unbeschränkt geschäftsfähig sind. Von der Teilnahme ausgeschlossen sind:
					<ul className="pl-8">
						<li className="list-disc">
							Mitarbeiter von Wilkinson Sword und der mit ihr verbundenen Unternehmen im Sinne von{" "}
							<strong>§ 15</strong> AktG und deren Angehörige
						</li>
						<li className="list-disc">
							Mitarbeiter von Kooperationspartnern des Veranstalters, die an der Gestaltung oder
							Durchführung der Aktion beteiligt waren oder sind
						</li>
						<li className="list-disc">
							Alle Mitarbeiter der <strong>Dirk Rossmann GmbH</strong>
						</li>
					</ul>
					Eine gewerbliche Teilnahme oder eine durch Dritte vermittelte Teilnahme (z.B. Gewinnspielservices,
					Makler oder Suchmaschinen) ist nicht zulässig. Außerdem behält sich der Veranstalter das Recht vor,
					Personen von der Teilnahme auszuschließen, bei denen der Verdacht besteht, dass sie sich bei der
					Teilnahme unerlaubter Hilfsmittel bedienen oder versuchen, sich oder Dritten durch Manipulation
					unfaire Vorteile zu verschaffen. Der Ausschluss kann in diesem Fall nach der Teilnahme erfolgen. Der
					Veranstalter hat das Recht die Gewinnausschüttung zu verweigern bzw. jeglichen Gewinn
					zurückzufordern.
				</p>
				<h3 className="h3 text-black py-4">3. Teilnahmevoraussetzung / Aktionsprodukte</h3>
				<p className="mb-8 ">
					Voraussetzung für die Teilnahme an der Verlosung ist der{" "}
					<strong>Kauf eines Aktionsproduktes</strong> innerhalb des Aktionszeitraums in der Filiale des
					teilnehmenden Händlers <strong>Rossmann</strong> oder über{" "}
					<a href="https://www.rossmann.de" target="_blank" className="underline">
						www.rossmann.de
					</a>
					. Der Teilnahmezeitraum für den Rechnungseingangs-Upload ist vom{" "}
					<strong>25.05.2026 bis zum 05.07.2026, 23:59 Uhr</strong> (deutsche Zeit) ("Teilnahmezeitraum").
				</p>
				<p className="mb-8 ">
					Die Aktion gilt für alle folgenden Produkte ("Produkte"), die im Aktionszeitraum bei einem
					teilnehmenden Händler in Deutschland oder online innerhalb Deutschlands ("Teilnehmender Händler")
					gekauft werden:
					<ul className="pl-8">
						<li className="list-disc">Bulldog Original Shampoo 300ml</li>
						<li className="list-disc">Bulldog Original 2in1 Bart & Gesichtsreiniger</li>
						<li className="list-disc">Bulldog Anytime Daily Feuchtigkeitscreme LSF 30 & 50, 75ml</li>
						<li className="list-disc">Bulldog Original Feuchtigkeitscreme</li>
						<li className="list-disc">Bulldog Duschgel - Zitrone & Bergamotte, 300ml</li>
						<li className="list-disc">Bulldog Duschgel - Original, 300ml</li>
						<li className="list-disc">
							Bulldog Sensitive Rasierer & Bulldog Sensitive 4er- und 8er Rasierklingen
						</li>
						<li className="list-disc">Bulldog schützende Feuchtigkeitscreme LSF 15</li>
						<li className="list-disc">Bulldog sensitive schäumendes Rasiergel</li>
						<li className="list-disc">Bulldog Original Bartöl</li>
						<li className="list-disc">Bulldog Original Aftershave Balsam</li>
						<li className="list-disc">Bulldog Original Waschgel</li>
						<li className="list-disc">Bulldog Age Defence Feuchtigkeitscreme</li>
						<li className="list-disc">Bulldog Age Defence Serum</li>
						<li className="list-disc">Bulldog Original Bartshampoo & Conditioner</li>
					</ul>
				</p>
				<p className="mb-8 ">
					Teilnehmende Händler innerhalb Deutschlands:
					<ul className="pl-8">
						<li className="list-disc">Dirk Rossmann GmbH</li>
					</ul>
				</p>
				<p className="mb-8 ">
					Die Teilnahmeberechtigung ergibt sich aus dem jeweiligen Rechnungsbeleg, auf dem das Aktionsprodukt
					aufgeführt ist. Jeder Rechnungsbeleg darf <strong>nur einmal</strong> zur Teilnahme am Gewinnspiel
					verwendet werden und stellt somit nur <strong>eine</strong> Gewinnchance dar, auch wenn mehrere
					Produkte gekauft wurden.
				</p>
				<p className="mb-8 ">
					Jeder Teilnehmer kann <strong>nur in seinem eigenen Namen</strong> teilnehmen.
				</p>
				<h3 className="h3 text-black py-4">4. Teilnahme & Gewinnbenachrichtigung</h3>
				<p className="mb-8 ">
					Die Teilnahme an der Aktion ist nur durch Hochladen des Rechnungsbelegs und Eingabe der
					erforderlichen Daten auf der Aktionsseite unter{" "}
					<a
						href="https://de.bulldogskincare.com/pages/gewinnspiel-ironman-2026"
						target="_blank"
						className="underline"
					>
						https://de.bulldogskincare.com/pages/gewinnspiel-ironman-2026
					</a>{" "}
					("Aktionsseite") möglich.
				</p>
				<p className="">
					Der Scan oder das Foto des Original-Rechnungsbelegs muss folgende Punkte deutlich aufzeigen:
				</p>
				<ul className="pl-8 pb-6">
					<li className="list-disc">das teilnehmende Produkt</li>
					<li className="list-disc">das teilnehmende Geschäft</li>
					<li className="list-disc">den Preis</li>
					<li className="list-disc">die Rechnungsbelegnummer</li>
					<li className="list-disc">das Kaufdatum</li>
				</ul>
				<p className="mb-8 ">
					Die Datenschutzbestimmungen und diese Teilnahmebedingungen müssen akzeptiert werden.
				</p>
				<p className="mb-8 ">
					Der Teilnehmer hat dafür Sorge zu tragen, dass durch seine Teilnahme keine Ansprüche wegen
					Verletzung der Privatsphäre oder des allgemeinen Persönlichkeitsrechts entstehen, keine Rechte
					und/oder Interessen Dritter verletzt werden und keine Zahlungsansprüche jeglicher Art entstehen.
				</p>
				<p className="mb-8 ">
					Eine Kombination mit anderen Gutscheinen oder Promotionen ist nicht möglich. Der Gewinnanspruch ist
					nicht auf Dritte übertragbar.
				</p>
				<p className="mb-8 ">
					Pro Teilnehmer sind mehrere Teilnahmen an diesem Gewinnspiel möglich. Pro Teilnahme ist nur ein
					Kaufbeleg anwendbar. Die Teilnahme mittels automatisierter Datenverarbeitungsprozesse ist
					ausgeschlossen. Eine regelwidrige Teilnahme eines Teilnehmers an diesem Gewinnspiel hat seinen
					Spielausschluss zur Folge.
				</p>
				<p className="mb-8 ">
					Der Veranstalter behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion jederzeit für
					etwaige Nachprüfungen einzufordern. Wenn gefordert, muss der Teilnehmer den Kassenbon an den
					Veranstalter bzw. an die Magellan GmbH senden.
				</p>
				<p className="mb-8 ">
					Die Gewinner werden innerhalb von zwei Wochen nach Aktionsende per Zufallsziehung aus allen gültigen
					Teilnahmen ermittelt. Die Gewinner werden per E-Mail informiert und müssen formlos (per E-Mail) die
					Gewinnannahme innerhalb von 14 Tagen bestätigen. Wenn ein Gewinner die Annahme des Gewinns nicht
					innerhalb von 14 Tagen bestätigt, verfällt der Gewinn, und ein anderer Gewinner wird nach dem
					Ermessen des Veranstalters aus dem ursprünglichen Pool der teilnahmeberechtigten Beiträge
					ausgewählt. Der Teilnehmer ist für die Richtigkeit der angegebenen Kontaktdaten verantwortlich. Kann
					der Gewinner aufgrund unvollständiger oder falscher Kontaktdaten nicht kontaktiert werden, verfällt
					der Gewinn, und ein anderer Gewinner wird gemäß den Bestimmungen dieser Klausel ausgewählt.
				</p>
				<h3 className="h3 text-black py-4">5. Gewinne</h3>
				<p className="mb-8 ">
					Im Aktionszeitraum gibt es die Chance auf einen der folgenden Gewinne pro Teilnehmer:
					<ul className="pl-8">
						<li className="list-disc">1x Quintana Roo Service Course Road Bike</li>
						<li className="list-disc">
							10x Merch Pakete (bestehend aus einem Bulldog T-Shirt, ein Paar Bulldog-Socken und einem
							Bulldog-Bademantel)
						</li>
						<li className="list-disc">
							100x Bulldog Startersets (bestehend aus einem Original Rasierer, einer Original
							Feuchtigkeitscreme, einem Original Bartöl, einem Original 2in1 2in1 Bart & Gesichtsreiniger,
							einem Original Duschgel)
						</li>
						<li className="list-disc"> 500x 5€ Rossmann Gutscheine </li>
					</ul>
				</p>
				<p className="mb-8 ">
					Die Gewinne werden per Zufallsprinzip verteilt. Für den Fall, dass ein Preis nicht verfügbar ist,
					behält sich der Veranstalter vor, einen gleich- oder höherwertigen Preis zu vergeben.
				</p>
				<p className="mb-8 ">
					Die Vergabe der Gewinne findet nur unter den Teilnehmern statt, die sämtliche für die Teilnahme an
					dem Gewinnspiel notwendigen Angaben vollständig, verständlich und richtig übermittelt haben.
				</p>
				<p className="mb-8 ">
					Eine Barauszahlung der Gewinne ist nicht möglich. Gewinnansprüche können nicht auf andere Personen
					übertragen oder abgetreten werden. Der Rechtsweg ist ausgeschlossen.
				</p>
				<p className="mb-8 ">
					Die Zustellung der Gewinne erfolgt per Paketdienst innerhalb von 4-6 Wochen nach Gewinnspielende an
					die angegebene Adresse. Der Versand erfolgt nur innerhalb Deutschlands. Für den Fall, dass der
					Gewinn aus Gründen, die der Gewinner zu vertreten hat, nicht zugestellt werden kann, entfällt der
					Gewinnanspruch und der Veranstalter kann einen neuen Gewinner ermitteln.
				</p>
				<p className="mb-8 ">Ein Gewinner kann jederzeit auf seinen Gewinn verzichten.</p>
				<h3 className="h3 text-black py-4">6. Datenschutz</h3>
				<p className="mb-8 ">
					Die nachfolgenden Datenschutzhinweise informieren die Teilnehmer über Art, Umfang und Zweck der
					Erhebung und Verwendung ihrer personenbezogenen Daten im Rahmen der Aktion durch den Veranstalter
					als datenschutzrechtlich Verantwortlichem. Die rechtliche Basis für die Datenverarbeitung stellt die
					Einwilligung des Teilnehmenden dar.
				</p>
				<p className="mb-8 ">
					Mit der Teilnahme an der Aktion und der Erteilung der Einwilligung willigt der Teilnehmer ein, dass
					seine personenbezogenen Daten (Name, Geburtsdatum, E-Mail-Adresse, Adresse) zum Zwecke der
					Durchführung und Verwaltung des Gewinnspiels/ der Werbeaktion gespeichert und verarbeitet werden
					dürfen.
				</p>
				<p className="mb-8 ">
					Eine Weitergabe von Daten an Dritte erfolgt nur, wo dies für die Abwicklung der Aktion erforderlich
					und gesetzlich zulässig ist.
				</p>
				<p className="mb-8 ">
					Die personenbezogenen Daten der Teilnehmer werden von der Magellan GmbH erhoben und von der Ludwig
					Zenger Industrie-Service GmbH und Magellan GmbH verarbeitet, jeder fungiert als Auftragsverarbeiter
					im Auftrag des Veranstalters, für den Zweck der Teilnahme, Durchführung und Abwicklung der
					Gewinnspiele, einschließlich der Zustellung der Preise und ggf. der Veröffentlichung des Vornamens
					des Gewinners.
				</p>
				<p className="mb-8 ">
					Die folgenden personenbezogenen Daten werden verarbeitet:
					<ul className="pl-8">
						<li className="list-disc">Vor- und Nachname</li>
						<li className="list-disc">Adresse</li>
						<li className="list-disc">E-Mail-Adresse</li>
					</ul>
				</p>
				<p className="mb-8 ">
					Die oben genannten personenbezogenen Daten können außerdem zu Werbezwecken verwendet werden, wenn
					der Teilnehmer dem Erhalt von Werbemitteilungen zugestimmt hat. Der Veranstalter wird die
					personenbezogenen Daten der Teilnehmer, die dem Erhalt von Werbeinformationen nicht zugestimmt
					haben, bis zum 30. September 2026 löschen.
				</p>
				<p className="mb-8 ">
					Weitere Informationen darüber, wie der Veranstalter personenbezogene Daten verarbeitet,
					einschließlich Informationen über die Rechte der Teilnehmer, finden Sie unter:{" "}
					<a
						href="https://de.bulldogskincare.com/policies/privacy-policy"
						target="_blank"
						className="underline"
					>
						https://de.bulldogskincare.com/policies/privacy-policy
					</a>
				</p>
				<p className="mb-8 ">
					Die Teilnehmer haben jederzeit das Recht:
					<ul className="pl-8">
						<li className="list-disc">
							Auskunft über die Verarbeitung ihrer personenbezogenen Daten zu erhalten
						</li>
						<li className="list-disc">
							die Berichtigung, Löschung oder Einschränkung der Verarbeitung ihrer personenbezogenen Daten
							zu verlangen
						</li>
						<li className="list-disc">
							die zur Verfügung gestellten personenbezogenen Daten in einem strukturierten, allgemein
							gebräuchlichen und maschinenlesbaren Format zu erhalten und an einen anderen für die
							Verarbeitung Verantwortlichen zu übermitteln.{" "}
						</li>
						<li className="list-disc">
							Der Verarbeitung ihrer personenbezogenen Daten aus Gründen, die sich aus ihrer besonderen
							Situation ergeben, zu widersprechen.
						</li>
						<li className="list-disc">
							Eine Beschwerde bei einer zuständigen Aufsichtsbehörde einzureichen, insbesondere in dem
							Bundesland ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Ortes mutmaßlichen
							Verletzung.
						</li>
					</ul>
				</p>
				<p className="mb-8 ">
					Die Teilnehmer haben das Recht, ihre Einwilligung zur Verarbeitung ihrer persönlichen Daten
					jederzeit zu widerrufen. Der Widerruf der Einwilligung hat keinen Einfluss auf die Rechtmäßigkeit
					der Verarbeitung, die auf der Grundlage der Einwilligung vor Widerruf erfolgt ist.
				</p>
				<p className="mb-8 ">Zu diesem Zweck können sich die Teilnehmer an die folgende Adresse wenden:</p>
				<p className="mb-8 ">Wilkinson Sword GmbH, Schützenstraße 110, 42659 Solingen, Deutschland</p>
				<p className="mb-8 ">
					Die Bitte um Auskunft und Widerruf kann der Teilnehmer auch per E-Mail an den Veranstalter unter{" "}
					<a href="mailto:bulldog@gewinnspiel-2026.de" className="underline">
						bulldog@gewinnspiel-2026.de
					</a>{" "}
					richten.
				</p>
				<p className="mb-8 ">Im Übrigen gelten die allgemeinen Datenschutzrichtlinien des Veranstalters.</p>
				<h3 className="h3 text-black py-4">7. Haftung</h3>
				<p className="mb-8 ">
					Der Veranstalter haftet für eigenes Verschulden und grobe Fahrlässigkeit, sowie das seiner
					gesetzlichen Vertreter, leitenden Angestellten oder sonstigen Erfüllungsgehilfen nach den
					gesetzlichen Bestimmungen. Gleiches gilt für die Übernahme von Garantien oder sonstiger
					verschuldensunabhängiger Haftung sowie für Ansprüche nach dem Produkthaftungsgesetz oder bei
					schuldhafter Verletzung von Leben, Körper oder Gesundheit.
				</p>
				<p className="mb-8 ">
					Der Veranstalter haftet für die eigene, die seiner Vertreter, leitenden Angestellten und einfachen
					Erfüllungsgehilfen einfach fahrlässige Verletzung wesentlicher Vertragspflichten, d.h. solcher
					Pflichten, auf deren ordnungsgemäße Erfüllung die Teilnehmer bei der Durchführung der Aktion
					regelmäßig vertrauen dürfen; in diesem Fall ist die Haftung der Höhe nach auf den typischerweise
					vorhersehbaren Schaden begrenzt.
				</p>
				<p className="mb-8 ">Jede weitere Haftung des Veranstalters ist ausgeschlossen.</p>
				<h3 className="h3 text-black py-4">8. Einverständniserklärung</h3>
				<p className="mb-8 ">
					Der Teilnehmer erklärt sich einverstanden, dass sein Name im Falle eines Gewinns öffentlich
					bekanntgegeben wird.
				</p>
				<h3 className="h3 text-black py-4">9. Beendigung der Aktion</h3>
				<p className="mb-8 ">
					Die Aktion kann jederzeit ohne Vorankündigung und ohne Angabe von Gründen durch den Veranstalter
					geändert, verlängert, für einen vorübergehenden Zeitraum ausgesetzt oder vorzeitig beendet werden.
					Hieraus entstehen keine Ansprüche.
				</p>
				<h3 className="h3 text-black py-4">10. Sonstiges</h3>
				<p className="mb-8 ">
					Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Übereinkommens über
					Verträge über den internationalen Warenkauf (CISG).
				</p>
				<p className="mb-8 ">
					Sollten Bestimmungen der Teilnahmebedingungen unwirksam sein oder werden, so bleibt die Regelung der
					übrigen Teilnahmebedingungen unberührt. An ihre Stelle tritt diejenige gültige Bestimmung, die dem
					Zweck der unwirksamen Bestimmung am nächsten kommt.
				</p>
				<p className="mb-8 ">
					Der Veranstalter behält sich das Recht vor, diese Teilnahmebedingungen jederzeit und ohne vorherige
					Ankündigung zu ändern. Die Änderung tritt mit der Veröffentlichung der geänderten
					Teilnahmebedingungen auf{" "}
					<a
						href="https://de.bulldogskincare.com/pages/gewinnspiel-ironman-2026"
						target="_blank"
						className="underline"
					>
						https://de.bulldogskincare.com/pages/gewinnspiel-ironman-2026
					</a>{" "}
					in Kraft.
				</p>
				<p className="mb-8 ">Die Teilnahmebedingungen sind für die Dauer der Aktion gültig.</p>
				<p className="mb-8 ">
					Sämtliche Fragen oder Anmerkungen zur Aktion sind per E-Mail an{" "}
					<a href="mailto:bulldog@gewinnspiel-2026.de" className="underline">
						bulldog@gewinnspiel-2026.de
					</a>{" "}
					zu richten.
				</p>
			</div>
			<div className="py-10 pt-5  text-center">
				<button onClick={() => navigate(-1)} className="btn btn-green">
					Zurück
				</button>
			</div>
		</>
	)
}
export default Terms
